import { AppResponse } from '@/shared/application/response/app-response';
import { ServerResponse } from '@/shared/types/server/response/server-response';
import { toast } from 'sonner';

export class ServerApiResponseManager {
  public static handleMessages(responseData: unknown) {
    if (AppResponse.isValid(responseData)) {
      const appResponse = responseData as ServerResponse;

      // Faz um reverse() nas mensagens, pra exibir elas na ordem correta, pois o toast() do 'sonner' exibe invertido.
      // Exibe a mensagem em si como aviso, pois é uma resposta esperada.
      for (const message of appResponse.messages.reverse()) {
        toast.success(message.title, {
          description: message.description,
        });
      }

      return;
    }
  }

  public static handleSuccessSubmit(responseData: unknown) {
    if (AppResponse.isValid(responseData)) {
      const appResponse = responseData as ServerResponse;

      // Faz um reverse() nas mensagens, pra exibir elas na ordem correta, pois o toast() do 'sonner' exibe invertido.
      // Exibe a mensagem em si como aviso, pois é uma resposta esperada.
      for (const message of appResponse.messages.reverse()) {
        toast.success(message.title, {
          description: message.description,
        });
      }

      return;
    }
  }
}
